// import { NavLink } from "react-router-dom";
// import { publicUrlFor } from "../../../../globals/constants";

// export default function SectionWhyChooseUs3({ _data }) {
//   return (
//     <>
//       <div className="section-full p-t120 p-b50 tw-why-choose-area3 tw-why-choose-area3-top">
//         <div className="container">
//           <div className="tw-why-choose3-section">
//             <div className="row">
//               <div className="col-xl-7 col-lg-7 col-md-12">
//                 <div className="tw-why-choose-right">
//                   <div className="tw-why-choose-media2 slide-top shine-effect">
//                     <div className="shine-box">
//                       <img
//                         src={publicUrlFor("/assets/images/w-choose/why1.png")}
//                         alt="#"
//                       />
//                     </div>
//                   </div>
//                   <div className="tw-why-choose-media1 shine-effect">
//                     <div className="shine-box">
//                       <img
//                         src={publicUrlFor("/assets/images/w-choose/why3.png")}
//                         alt="#"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-xl-5 col-lg-5 col-md-12">
//                 <div className="tw-why-choose-left">
//                   {/* TITLE START*/}
//                   <div className="section-head left wt-small-separator-outer">
//                     <div className="wt-small-separator site-text-primary">
//                       <div>{_data.title}</div>
//                     </div>
//                     <h2 className="wt-title">{_data.subtitle}</h2>
//                   </div>
//                   {/* TITLE END*/}
//                   <strong>{_data.description.short}</strong>
//                   <p className="section-head-text">{_data.description.long}</p>

//                   <div>
//                     <ul className="list-disc pl-5 space-y-2">
//                       {_data.description.points.map((point, index) => {
//                         const [title, ...rest] = point.split(":");
//                         return (
//                           <li key={index}>
//                             <span className="font-bold text-black">
//                               {title}:
//                             </span>
//                             {rest.join(":")}
//                           </li>
//                         );
//                       })}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

import { useEffect, useRef } from "react";

export default function SectionWhyChooseUs3({ _data }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const iframe = videoRef.current;

    if (!iframe) return;

    const sendCommand = (func, args = []) => {
      iframe.contentWindow?.postMessage(
        JSON.stringify({
          event: "command",
          func,
          args,
        }),
        "https://www.youtube.com",
      );
    };

    const handleEnterViewport = () => {
      // Start playing
      sendCommand("playVideo");

      // Try to automatically turn sound on
      // Browser may block this, but we attempt it.
      setTimeout(() => {
        sendCommand("unMute");
        sendCommand("setVolume", [100]);
      }, 300);
    };

    const handleLeaveViewport = () => {
      // Pause video when leaving viewport
      sendCommand("pauseVideo");
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handleEnterViewport();
        } else {
          handleLeaveViewport();
        }
      },
      {
        threshold: 0.5,
      },
    );

    observer.observe(iframe);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="section-full p-t120 p-b50 tw-why-choose-area3 tw-why-choose-area3-top">
      <div className="container">
        <div className="tw-why-choose3-section">
          <div className="row">
            {/* =========================================
                LEFT — TRACKK VIDEO
            ========================================= */}
            <div className="col-xl-7 col-lg-7 col-md-12">
              <div className="tw-why-choose-video">
                <div className="tw-why-choose-video-box">
                  <iframe
                    ref={videoRef}
                    src="https://www.youtube.com/embed/ukqD0hUud9U?enablejsapi=1&autoplay=1&mute=1&loop=1&playlist=ukqD0hUud9U&controls=0&rel=0&playsinline=1"
                    title="Pickkup"
                    className="tw-why-choose-youtube"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>

            {/* =========================================
                RIGHT — CONTENT
            ========================================= */}
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div className="tw-why-choose-left">
                {/* TITLE */}
                <div className="section-head left wt-small-separator-outer">
                  <div className="wt-small-separator site-text-primary">
                    <div>{_data.title}</div>
                  </div>

                  <h2 className="wt-title">{_data.subtitle}</h2>
                </div>

                {/* SHORT DESCRIPTION */}
                <strong>{_data.description.short}</strong>

                {/* LONG DESCRIPTION */}
                <p className="section-head-text">{_data.description.long}</p>

                {/* POINTS */}
                <div>
                  <ul className="list-disc pl-5 space-y-2">
                    {_data.description.points.map((point, index) => {
                      const [title, ...rest] = point.split(":");

                      return (
                        <li key={index}>
                          <span className="font-bold text-black">{title}:</span>

                          {rest.join(":")}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
